import { render } from "./Sidebar.vue?vue&type=template&id=54197d66&scoped=true&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=54197d66&scoped=true&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=54197d66&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54197d66"]])

export default __exports__